import * as React from 'react';
import templates from '../../data/templates';
import useDraft from '../hooks/useDraft';

export default function TemplateChanger() {
    const {
        draft: { template },
        changeTemplate,
    } = useDraft();

    return (
        <div className="control">
            <label htmlFor="template-selector">change template</label>
            <select
                id="template-selector"
                onChange={({ target: { value } }) => {
                    changeTemplate(value);
                }}
                value={template}
            >
                <option value="">...change template</option>
                {Object.entries(templates).map(([key, template]) => (
                    <option key={key} value={key}>
                        {template.meta.name}
                    </option>
                ))}
            </select>
        </div>
    );
}
